<template>
    <div class="manage">
        <div class="manage-header">
            <el-form :inline="true" :model="userForm">
                <el-form-item>
                    <el-input placeholder="请输入名称" v-model="userForm.nickName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="common-table">
            <el-table stripe height="90%" :data="filteredTableData" style="width: 100%;">
                <el-table-column prop="nickName" label="昵称"></el-table-column>
                <el-table-column prop="avatarUrl" label="头像">
                    <template #default="scope">
                        <el-avatar :src="scope.row.avatarUrl"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column prop="createdAt" label="登录时间">
                    <template #default="scope">
                        {{ new Date(scope.row.createdAt).toLocaleString() }}
                    </template>
                    </el-table-column>
            </el-table>
            <div class="">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserPage',
    data() {
        return {
            dialogVisible: false,
            tableData: [], // 原始数据
            filteredData: [], // 过滤后的数据
            userForm: {
                nickName: '',
            },
            currentPage: 1,
            pageSize: 10,
            total: 0
        }
    },
    computed: {
        // 计算当前页显示的数据
        filteredTableData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredData.slice(start, end);
        }
    },
    methods: {
        getList() {
            this.$http.get('/api/auth/users')
                .then(response => {
                    this.tableData = response.data.data;
                    this.filteredData = [...this.tableData];
                    this.total = this.filteredData.length;
                    console.log('用户列表',response.data.data)
                }).catch(error => {
                    console.error('获取用户失败:', error);
                    this.$message.error('获取用户失败');
                });
        },
        handleSearch() {
            // 过滤数据
            if (this.userForm.nickName.trim()) {
                this.filteredData = this.tableData.filter(item => 
                    item.nickName.toLowerCase().includes(this.userForm.nickName.toLowerCase())
                );
            } else {
                this.filteredData = [...this.tableData];
            }
            this.total = this.filteredData.length;
            this.currentPage = 1; // 重置到第一页
        },
        handleReset() {
            // 重置查询表单
            this.userForm.nickName = '';
            // 恢复显示所有数据
            this.filteredData = [...this.tableData];
            this.total = this.filteredData.length;
            this.currentPage = 1;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 每页条数变化时回到第一页
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        }
    },
    mounted() {
        this.getList();
    }
}
</script>

<style lang="less" scoped>
.manage {
    height: 90%;

    /* 确保 .manage 有一个明确的高度 */
    .manage-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .common-table {
        position: relative;
        height: calc(100% - 62px);
        // height: 80%;

        /* 基于 .manage 的高度计算 */
        .pager {
            position: absolute;
            bottom: 0;
            right: 20px;
        }
    }
}
</style>